import { Language } from 'types';

export const languageToLocale: Record<Language, string> = {
  English: 'en',
  Spanish: 'es',
  Portuguese: 'pt',
  Amharic: 'am',
  Italian: 'it',
  French: 'fr',
  Arabic: 'ar',
  'Tunisian Arabic': 'ar-TN',
  'Kinyarwanda': 'rw-RW',
};
